import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingComponent } from './shared/components/loading/loading.component';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from './shared/components/navbar/navbar.component';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'hub-root',
  standalone: true,
  imports: [CommonModule, LoadingComponent, RouterOutlet, NavbarComponent, ToastModule],
  template: `
    @defer {
      <hub-navbar />
      <hub-loading />
      <div class="tw-p-4">
        <router-outlet></router-outlet>

        <div class="card flex justify-content-center gap-2"><p-toast position="top-center" key="tl"></p-toast></div>
      </div>
    } @loading (minimum 1s) {
      <div>Carregando...</div>
    }
  `,
  styleUrl: './app.component.scss',
})
export class AppComponent {}
